/** @format */

import {Box, ListItem, ListItemText, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import PauseCircleFilledOutlinedIcon from '@mui/icons-material/PauseCircleFilledOutlined';
import CircularProgress from '@mui/material/CircularProgress';

import TransparentSmallButton from 'components/buttons/TransparentSmallButton';

import {sensorName} from 'helpers/sensor_names';

const PREFIX = 'ExcludedRow';

const classes = {
  row: `${PREFIX}-row`,
  icon: `${PREFIX}-icon`,
  title: `${PREFIX}-title`,
  subtitle: `${PREFIX}-subtitle`,
  startSensorButton: `${PREFIX}-startSensorButton`,
  startSensorButtonIcon: `${PREFIX}-startSensorButtonIcon`,
  startSensorButtonProgressIcon: `${PREFIX}-startSensorButtonProgressIcon`,
};

const StyledBox = styled(Box)(({theme}) => ({
  [`& .${classes.row}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#202020',
    borderRadius: 8,
    cursor: 'pointer',
    marginTop: theme.spacing(2),
    padding: theme.spacing(4),
    position: 'relative',
    paddingRight: theme.spacing(4),
  },

  [`& .${classes.icon}`]: {
    width: '48px',
    height: '48px',
    borderRadius: '8px',
    background: '#2B2B2B',
    marginRight: theme.spacing(4),
  },

  [`& .${classes.title}`]: {
    color: '#D2D2D2',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '26px',
    letterSpacing: '0.169px',
    paddingRight: theme.spacing(2),
  },

  [`& .${classes.subtitle}`]: {
    color: theme.palette.text.primary,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '16px',
    paddingRight: theme.spacing(2),
  },

  [`& .${classes.startSensorButton}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    minWidth: '32px',
    width: '32px',
    height: '32px',
    borderRadius: '8px',
    background: '#2B2B2B',
    borderColor: 'transparent',
  },

  [`& .${classes.startSensorButtonIcon}`]: {
    fontSize: '16px',
    color: '#AE5658',
  },

  [`& .${classes.startSensorButtonProgressIcon}`]: {
    width: '24px !important',
    height: '24px !important',
  },
}));

const ExcludedRow = props => {
  const {t} = useTranslation();

  const handleClick = () => {
    props.onClick(props.check);
  };

  return (
    <StyledBox position='relative'>
      <ListItem className={classes.row} onClick={handleClick}>
        <ListItemText
          disableTypography
          primary={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box
                className={classes.icon}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <EmojiObjectsOutlinedIcon fontSize='small' htmlColor='#8B8B8B' />
              </Box>

              <Typography className={classes.title}>
                {t(sensorName(props.check.sensor.name))}
              </Typography>
            </Box>
          }
        />

        <TransparentSmallButton
          className={classes.startSensorButton}
          onClick={props.handleStartSensor}
        >
          {props.deleteSensorExclusionLoading ? (
            <CircularProgress className={classes.startSensorButtonProgressIcon} disableShrink />
          ) : (
            <PauseCircleFilledOutlinedIcon className={classes.startSensorButtonIcon} />
          )}
        </TransparentSmallButton>
      </ListItem>
    </StyledBox>
  );
};

export default ExcludedRow;
